// FIXME
import { createAction } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import {
  IS_DEV_ENV,
  IS_SENTRY_AVAILABLE,
  LOCALSTORAGE_ITEMS,
  SORT_DIRECTION,
  VOICE_VISIBILITY,
} from "../constants";
import { microphoneChange } from "actions/microphone";
import { privateVoicesCheck } from "./voice";
import { getCsrfToken } from "utils";
import eventsService from "services/events";
import localStorageService from "services/localStorage";
import { logger } from "utils/logger";

export const initAction = () => async (dispatch) => {
  dispatch(
    microphoneChange(
      localStorageService.getItem(LOCALSTORAGE_ITEMS.microphone.id) ||
        "default",
      localStorageService.getItem(LOCALSTORAGE_ITEMS.microphone.name) ||
        "default",
      true,
      false
    )
  );
  eventsService.config({ debug: IS_DEV_ENV });
  if (getCsrfToken()) {
    const { authenticate, updateLocalStorage } = await import("./auth");
    if (authenticate) {
      await dispatch(authenticate());
      const store = await import("../store/index");
      const {
        isAuthenticated,
        verified,
        loading,
        isTrial,
        localStorage: ls,
      } = store.default.getState().auth;
      if (isAuthenticated) {
        dispatch(
          privateVoicesCheck({
            offset: 0,
            limit: 1,
            sortKey: "rating",
            sortDirection: SORT_DIRECTION.desc,
            filters: { type: [VOICE_VISIBILITY.private] },
            privateVoicesCheck: true,
          })
        );
      }
    }
  } else {
    const { toggleGlobalLoading } = await import("./auth");
    dispatch(toggleGlobalLoading(false));
  }
};

export const initAppData = (user) => async (dispatch) => {
  // if regular user didn't accepted tou or didn't subscribed
  // don't load data from backend

  logger.info("init app data", user);

  eventsService.config({ user, debug: IS_DEV_ENV });

  if (IS_SENTRY_AVAILABLE) {
    Sentry.setUser({ id: user.id, email: user.email });
  }

  if (user.verified) {
    const { initWS } = await import("api/websockets");
    initWS(dispatch);
  }
};

export const clearStore = createAction("store/clear");
